import React, { useEffect, useRef, useState } from 'react';
import {
    GlobalButtonFinal,
    RenderModalWrapper,
} from '../GlobalStyles';

import messages from '../../../../src/messages';

import {
    faPlus,
    faCamera,
    faDownload,
} from '@fortawesome/pro-regular-svg-icons';
import NewProduct from '../../pages/newproduct/NewProduct';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DialogBuyCredits from '../dialogs/DialogBuyCredits';
import { useRouter } from 'next/router';
import io from 'socket.io-client';

import { getCookie } from 'cookies-next';
import { LoaderProducts } from '../../containers/Dashboard';
import { useAppContext } from '../../../../context/AuthContext';

export default function PackshotDetailModal({
    props: any,
    showRenderModalTransition,
    showRenderModal,
    packshotDetailOpened,
    packshotDetailName,
                                                setPackshotDetailOpened,
                                                language,
                                                setPackshotsList,
                                                loadRenderViews,
                                                closeRenderShow,
                                                packshotsList,
                                                choosePackshotDetail,
                                                packshotDetailThumbnail,
                                                packshotDetailDescription,
                                                triggerAlert,
                                                lowPackshotDate,
                                                lowPackshotUrl,
                                                lowQualityRendering,
                                                openRenderPackshot,
                                                pricingLow,
                                                mediumPackshotDate,
                                                mediumPackshotUrl,
                                                mediumQualityRendering,
                                                pricingMedium,
                                                highPackshotDate,
                                                highPackshotUrl,
                                                highQualityRendering,
                                                pricingHigh,
                                                estimatedTimeRenderLow,
                                                estimatedTimeRenderMid,
                                                estimatedTimeRenderHigh,
                                                lowQualityStatus,
                                                mediumQualityStatus,
                                                highQualityStatus,
                                                setLowQualityRendering,
                                                setMediumQualityRendering,
                                                setHighQualityRendering,
                                                setPackshotDetailThumbnail,
                                                setLowPackshotUrl,
                                                setMediumPackshotUrl,
                                                setHighPackshotUrl,
                                                triggerWarning,
                                                renderSceneViewOpenedUUID,loadRendersShow,
                                                loadTransitionRendersShow,
                                                versionProductUUID
}) {

    const router = useRouter();
    const { slug } = router.query;
    let socket;
    const [paymentStateSessionIDCallback, setPaymentStateSessionIDCallback] = useState(null);

    const [paymentStateCallback, setPaymentStateCallback] = useState(null);
    const { authData, refreshAuthInfo} = useAppContext();

    var [lowQualityStatusInner, setLowQualityStatusInner] = useState(null);
    var [mediumQualityStatusInner, setMediumQualityStatusInner] = useState(null);
    var [highQualityStatusInner, setHighQualityStatusInner] = useState(null);
    const [displayTimeLow, setDisplayTimeLow] = useState(null); // Bude v sekundách
    const [displayTimeMedium, setDisplayTimeMedium] = useState(null);
    const [displayTimeHigh, setDisplayTimeHigh] = useState(null);

    // Refs pro intervaly
    const intervalRefLow = useRef(null);
    const intervalRefMedium = useRef(null);
    const intervalRefHigh = useRef(null);

    // Refs pro uložení času startu odpočtu z pohledu klienta a původní délky
    // (pro případ, že bychom chtěli pauzovat/obnovovat čistě na klientovi, ale primárně se budeme řídit daty z backendu)
    const countdownStateRefLow = useRef({ startTimeMs: null, initialDurationMs: null, jobCreatedAtMs: null });
    const countdownStateRefMedium = useRef({ startTimeMs: null, initialDurationMs: null, jobCreatedAtMs: null });
    const countdownStateRefHigh = useRef({ startTimeMs: null, initialDurationMs: null, jobCreatedAtMs: null });

    const formatCountdownTime = (totalSeconds) => {
        if (totalSeconds === null || totalSeconds < 0) {
            // Můžeš vrátit placeholder nebo odhad z propů, pokud žádný odpočet neběží
            // Např. pokud je estimatedTimeRenderLow a totalSeconds je null:
            // return `${estimatedTimeRenderLow} min (odhad)`;
            return '--:--';
        }
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const startOrUpdateCountdown = (quality, jobCreatedAtISO, totalEstimatedMinutes) => {
        let intervalRef;
        let setDisplayTime;
        let countdownStateRef;

        if (quality === "low") {
            intervalRef = intervalRefLow;
            setDisplayTime = setDisplayTimeLow;
            countdownStateRef = countdownStateRefLow;
        } else if (quality === "medium") {
            intervalRef = intervalRefMedium;
            setDisplayTime = setDisplayTimeMedium;
            countdownStateRef = countdownStateRefMedium;
        } else if (quality === "high") {
            intervalRef = intervalRefHigh;
            setDisplayTime = setDisplayTimeHigh;
            countdownStateRef = countdownStateRefHigh;
        } else {
            return; // Neznámá kvalita
        }

        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        if (!jobCreatedAtISO || totalEstimatedMinutes === undefined || totalEstimatedMinutes === null) {
            console.warn(`[${quality}] Missing jobCreatedAtISO or totalEstimatedMinutes. Cannot start countdown.`);
            // Zde můžeme nastavit display time na null nebo na fallback z propů
            const fallbackTime = quality === "low" ? estimatedTimeRenderLow : quality === "medium" ? estimatedTimeRenderMid : estimatedTimeRenderHigh;
            setDisplayTime(fallbackTime ? fallbackTime * 60 : null); // Převedeme minuty z propů na sekundy
            return;
        }

        const jobCreatedAtMs = new Date(jobCreatedAtISO).getTime();
        const totalEstimatedMs = totalEstimatedMinutes * 60 * 1000; // Celkový odhad v ms
        const nowMs = Date.now();

        const elapsedMsSinceJobCreation = nowMs - jobCreatedAtMs;
        let remainingMs = totalEstimatedMs - elapsedMsSinceJobCreation;

        console.log(`[${quality}] Job created at: ${new Date(jobCreatedAtMs).toLocaleString()}, Estimated total: ${totalEstimatedMinutes} min, Elapsed since creation: ${Math.round(elapsedMsSinceJobCreation / 1000)}s, Remaining: ${Math.round(remainingMs / 1000)}s`);

        if (remainingMs <= 0) {
            setDisplayTime(0); // Nebo nějaký text "Zpracovávám..."
            console.log(`[${quality}] Countdown finished or time already passed.`);
            return;
        }

        // Uložíme si stav pro interní logiku setInterval
        countdownStateRef.current = {
            // Čas, kdy na klientovi *začal* tento konkrétní interval běžet
            clientIntervalStartTimeMs: Date.now(),
            // Zbývající čas v ms v okamžiku startu tohoto intervalu
            initialRemainingMsForInterval: remainingMs,
            jobCreatedAtMs: jobCreatedAtMs, // Čas vytvoření jobu na serveru
            totalEstimatedMs: totalEstimatedMs // Celkový odhadovaný čas jobu
        };

        setDisplayTime(Math.ceil(remainingMs / 1000)); // Počáteční zobrazení

        intervalRef.current = setInterval(() => {
            // Výpočet by měl ideálně stále vycházet z původního `jobCreatedAtMs` a `totalEstimatedMs`
            // aby se minimalizovala chyba z `setInterval`
            const currentNowMs = Date.now();
            const newElapsedMsSinceJobCreation = currentNowMs - countdownStateRef.current.jobCreatedAtMs;
            const newRemainingMs = countdownStateRef.current.totalEstimatedMs - newElapsedMsSinceJobCreation;

            if (newRemainingMs <= 0) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                setDisplayTime(0);
                console.log(`[${quality}] Countdown interval finished.`);
                // Zde by se nemělo nic dalšího dít, čekáme na 'completed', 'error', 'canceled'
            } else {
                setDisplayTime(Math.ceil(newRemainingMs / 1000));
            }
        }, 1000);
    };

    const stopCountdown = (quality) => {
        let intervalRef;
        let setDisplayTime; // Můžeme chtít nastavit čas na 0 nebo null
        // let countdownStateRef; // Pro případné vyčištění

        if (quality === "low") {
            intervalRef = intervalRefLow;
            setDisplayTime = setDisplayTimeLow;
            // countdownStateRef = countdownStateRefLow;
        } else if (quality === "medium") {
            intervalRef = intervalRefMedium;
            setDisplayTime = setDisplayTimeMedium;
            // countdownStateRef = countdownStateRefMedium;
        } else if (quality === "high") {
            intervalRef = intervalRefHigh;
            setDisplayTime = setDisplayTimeHigh;
            // countdownStateRef = countdownStateRefHigh;
        } else {
            return;
        }

        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            console.log(`[${quality}] Countdown stopped.`);
        }
        // Po zastavení (completed, error, canceled) můžeme čas nastavit
        // setDisplayTime(null); // nebo 0, nebo ponechat poslední hodnotu
        // countdownStateRef.current = { startTimeMs: null, initialDurationMs: null, jobCreatedAtMs: null };
    };


    const versionProductUUIDRef = useRef(versionProductUUID);
// Aktualizace ref při změně stavu
    useEffect(() => {
        versionProductUUIDRef.current = versionProductUUID;
    }, [versionProductUUID]);


    useEffect(() => {
       // console.log("STATUSlow", lowQualityStatus, lowQualityStatusInner);
        if(lowQualityStatus !== "completed"){
            setLowQualityStatusInner(lowQualityStatus);
        }
     //  setLowQualityStatusInner(lowQualityStatus);
    }, [lowQualityStatus]);
    useEffect(() => {
        if(mediumQualityStatus !== "completed"){
            setMediumQualityStatusInner(mediumQualityStatus);
        }
        //setMediumQualityStatusInner(mediumQualityStatus);
    }, [mediumQualityStatus]);
    useEffect(() => {
        if(highQualityStatus !== "completed"){
            setHighQualityStatusInner(highQualityStatus);
        }
                //console.log("STATUS", highQualityStatus, highQualityStatusInner);
       // setHighQualityStatusInner(highQualityStatus);
    }, [highQualityStatus]);
    // Vrací příjemnou hlášku pro danou kvalitu a stav renderu.
    function getRenderStatusMessage(quality, status) {
     //   console.log(quality, status);
        const messages = {
            low: {
                pending: language === "cs" ? "Připravuji packshot..." : "Preparing packshot...",
                canceled: language === "cs" ? "Packshot zrušen..." : "Packshot canceled...",
                queued_for_scene_prepare:  language === "cs" ? "Připravuji scénu..." : "Preparing scene...",
                preparing_scene:  language === "cs" ? "Připravuji scénu..." : "Preparing scene...",
                queued_for_render: language === "cs" ? "Čekám na render..." : "Waiting for render...",
                rendering:  language === "cs" ? "Renderuji packshot..." : "Rendering packshot...",
                completing:  language === "cs" ? "Zpracovávám packshot..." : "Processing packshot...",
                completed:  language === "cs" ? "Packshot je hotov!" : "Packshot is ready!"
            },
            medium: {
                pending: language === "cs" ? "Připravuji packshot..." : "Preparing packshot...",
                canceled: language === "cs" ? "Packshot zrušen..." : "Packshot canceled...",
                queued_for_scene_prepare:  language === "cs" ? "Připravuji scénu..." : "Preparing scene...",
                preparing_scene:  language === "cs" ? "Připravuji scénu..." : "Preparing scene...",
                queued_for_render: language === "cs" ? "Čekám na render..." : "Waiting for render...",
                rendering:  language === "cs" ? "Renderuji packshot..." : "Rendering packshot...",
                completing:  language === "cs" ? "Zpracovávám packshot..." : "Processing packshot...",
                completed:  language === "cs" ? "Packshot je hotov!" : "Packshot is ready!"
            },
            high: {
                pending: language === "cs" ? "Připravuji packshot..." : "Preparing packshot...",
                canceled: language === "cs" ? "Packshot zrušen..." : "Packshot canceled...",
                queued_for_scene_prepare:  language === "cs" ? "Připravuji scénu..." : "Preparing scene...",
                preparing_scene:  language === "cs" ? "Připravuji scénu..." : "Preparing scene...",
                queued_for_render: language === "cs" ? "Čekám na render..." : "Waiting for render...",
                rendering:  language === "cs" ? "Renderuji packshot..." : "Rendering packshot...",
                completing:  language === "cs" ? "Zpracovávám packshot..." : "Processing packshot...",
                completed:  language === "cs" ? "Packshot je hotov!" : "Packshot is ready!"
            }
        };

        // Normalizace vstupů na malá písmena
        const q = quality.toLowerCase();
        const s = status.toLowerCase();

        // Vrátíme větu, pokud existuje, jinak fallback hlášku.
        return messages[q] && messages[q][s]
            ? messages[q][s]
            : "Zpracování renderu.";
    }



    let handleClickBuyCredits = () => {
        console.log("CLICK BUY");
    };
    useEffect(() => {

        if(router.query.state && router.query.state.length > 0){

            handleClickBuyCredits();
            setPaymentStateSessionIDCallback(router.query.session_id);
            setPaymentStateCallback(router.query.state);
        }
    }, [router]);

    const [socketInited, setUpSocketInited] = useState(false);

    useEffect(() => {
console.log("socket initer",socketInited);
        if (!socketInited) {
            setUpSockets();
        }

    }, [socketInited]);


    // Vytvoření ref a nastavení počáteční hodnoty
    const renderSceneViewedUUIDRef = useRef(renderSceneViewOpenedUUID);

    // Aktualizace ref při změně someProp
    useEffect(() => {
        renderSceneViewedUUIDRef.current = renderSceneViewOpenedUUID;
    }, [renderSceneViewOpenedUUID]);

    // Vytvoření ref a nastavení počáteční hodnoty
    const packshotsListRef = useRef(null);

    // Aktualizace ref při změně someProp
    useEffect(() => {
        packshotsListRef.current = packshotsList;
    }, [packshotsList]);

    let showSupport2 = (e) => {
        console.log("SDD", e, window.Intercom,window);
        window.Intercom("show");
    };




    const downloadPackshot = async (packshotUrl) => {
        try {
            const response = await fetch(packshotUrl, { mode: 'cors' });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'packshot.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Chyba při stahování obrázku:', error);
        }
    }
    function updateRenderList(packshotsListRef, update) {
        // Získáme aktuální seznam renderů z ref
        const renderList = packshotsListRef.current;

        // Najdeme render, jehož uuid odpovídá hodnotě render_scene_view z update objektu
        const renderIndex = renderList.findIndex(item => item.uuid === update.render_scene_view);
        if (renderIndex === -1) {
            console.warn("Render scene view not found");
            return;
        }

        // Vybereme příslušnou položku
        const renderItem = renderList[renderIndex];

        // Aktualizujeme pole running_renders:
        // Pokud už položka se stejným uuid existuje, sloučíme nová data se stávajícími
        const runningIndex = renderItem.running_renders.findIndex(r => r.uuid === update.uuid);
        if (runningIndex !== -1) {
            renderItem.running_renders[runningIndex] = {
                ...renderItem.running_renders[runningIndex],
                ...update
            };
        } else {
            // Jinak přidáme nový update objekt
            renderItem.running_renders.push(update);
        }

        // Pokud update indikuje dokončení renderu (např. status "completed")
        if (update.status === "completed") {
            // Nastavíme, že render pro danou kvalitu je dokončen
            renderItem.completed_renders[update.quality] = true;
            // A odstraníme položku z running_renders
            renderItem.running_renders = renderItem.running_renders.filter(r => r.uuid !== update.uuid);
        }

        // Aktualizace thumbnail – pokud update obsahuje hodnotu download_path (novou URL)
        if (update.download_path) {
            renderItem.thumbnail = update.download_path;
        }

        // Uložíme aktualizovanou položku zpět do seznamu
        renderList[renderIndex] = renderItem;

        // Aktualizujeme stav v mateřské komponentě
        if(setPackshotsList){
            setPackshotsList([...renderList]);
        }

    }


    function getRenderViewName(packshotsListRef, update) {
        // Získáme aktuální seznam renderů z ref
        const renderList = packshotsListRef.current;

        // Vyhledáme render položku, jejíž uuid odpovídá hodnotě update.render_scene_view
        const renderItem = renderList.find(item => item.uuid === update.render_scene_view);

        // Vrátíme název view, pokud položku nalezli; jinak undefined
        return renderItem ? renderItem.name : undefined;
    }


    ///////////////////////////////////

    // estimatedTimeRenderLow
    const setUpSockets = () => {

        console.log("INIT EDIT ", "editor/"+versionProductUUIDRef.current)
        setUpSocketInited(true);
        if (socket !== undefined) {
            socket.close();
            socket.disconnect();
            socket.emit('end');
            socket.offAny();
            socket.removeAllListeners();
            socket = null;
        }


        socket = io(process.env.NEXT_PUBLIC_OBALERO_SOCKET_BASEPATH + 'render-jobs', {
           // reconnectionDelayMax: 10000,
            transports: ['websocket'],
            auth: {
                token: getCookie('userTeam'),
            },
        });
        socket.on('connect', () => {
            console.log("on connect socket renders");
        });
        socket.on('data', data => {

        });
        socket.on('create', data => {



            console.log("create slug ", data.product_version , versionProductUUIDRef.current);

            if(data.product_version === versionProductUUIDRef.current){
                console.log("create", data);


                const jobCreatedAt = data.created?.datetime; // Předpoklad: '2023-01-01T12:00:00Z'
                const estimatedMinutes = data.approximate_time; // Předpoklad: číslo (např. 4 pro low)

                if (data.quality === "low") {
                    setLowQualityStatusInner("pending");
                    setLowQualityRendering(true); // Indikuje, že render běží
                    // Pokud `create` přichází pro nový job, který ještě neběží
                    if (jobCreatedAt && estimatedMinutes !== undefined) {
                        console.log(`[low] Starting countdown from CREATE event. Created: ${jobCreatedAt}, Estimated: ${estimatedMinutes} min`);
                        startOrUpdateCountdown("low", jobCreatedAt, estimatedMinutes);
                    } else {
                        // Fallback na prop, pokud data z 'create' nejsou kompletní
                        console.log(`[low] Create event missing time data, falling back to prop: ${estimatedTimeRenderLow} min`);
                        startOrUpdateCountdown("low", new Date().toISOString(), estimatedTimeRenderLow); // Použijeme aktuální čas jako start
                    }
                }
                if (data.quality === "medium") {
                    setMediumQualityStatusInner("pending");
                    setMediumQualityRendering(true);
                    const estTime = data.approximate_time !== undefined ? data.approximate_time : estimatedTimeRenderMid;
                    const createdAt = data.created?.datetime ? data.created?.datetime : new Date().toISOString();
                    startOrUpdateCountdown("medium", createdAt, estTime);
                }
                if (data.quality === "high") {
                    setHighQualityStatusInner("pending");
                    setHighQualityRendering(true);
                    const estTime = data.approximate_time !== undefined ? data.approximate_time : estimatedTimeRenderHigh;
                    const createdAt = data.created?.datetime ? data.created?.datetime : new Date().toISOString();
                    startOrUpdateCountdown("high", createdAt, estTime);
                }

                updateRenderList(packshotsListRef, data);
                refreshAuthInfo();
            }


        });
        socket.on('update', data => {

            console.log("update versionProductUUID ", data.product_version , versionProductUUIDRef.current);

            if(data.product_version === versionProductUUIDRef.current){
                console.log("update", packshotsListRef.current, data, renderSceneViewedUUIDRef.current, data.render_scene_view );
                updateRenderList(packshotsListRef, data);

                if (data.status === 'completed') {
                    triggerAlert(  language ==="cs" ? "Váš nový packshot " + intl.formatMessage({ id: getRenderViewName(packshotsListRef,data) }) + " in "+data.quality+"-res je hotový!" : "Your new packshot " +  intl.formatMessage({ id: getRenderViewName(packshotsListRef,data) }) + " in "+data.quality+"-res is ready!")
                    loadRenderViews();
                    refreshAuthInfo();

                }
                if(data.render_scene_view  === renderSceneViewedUUIDRef.current){
                    if (data.status === 'pending') {

                        if(data.quality === "low"){
                            setLowQualityRendering(true);
                            setLowQualityStatusInner("pending");

                        }
                        if(data.quality === "medium"){

                            setMediumQualityRendering(true);
                            setMediumQualityStatusInner("pending");

                        }
                        if(data.quality === "high"){
                            setHighQualityStatusInner("pending");
                            setHighQualityRendering(true);

                        }

                        // setRenderSentence('Creating packshot...');
                    }
                    if (data.status === 'queued_for_scene_prepare') {
                        if(data.quality === "low"){

                            setLowQualityStatusInner("queued_for_scene_prepare");
                            setLowQualityRendering(true);
                        }
                        if(data.quality === "medium"){
                            setMediumQualityStatusInner("queued_for_scene_prepare");
                            setMediumQualityRendering(true);
                        }
                        if(data.quality === "high"){
                            setHighQualityStatusInner("queued_for_scene_prepare");
                            setHighQualityRendering(true);
                        }


                    }
                    if (data.status === 'queued_for_render') {
                        // setRenderSentence('Waiting for render...');
                        if(data.quality === "low"){
                            setLowQualityStatusInner("queued_for_render");
                            setLowQualityRendering(true);
                        }
                        if(data.quality === "medium"){
                            setMediumQualityStatusInner("queued_for_render");
                            setMediumQualityRendering(true);
                        }
                        if(data.quality === "high"){
                            setHighQualityStatusInner("queued_for_render");
                            setHighQualityRendering(true);
                        }
                    }
                    if (data.status === 'rendering') {
                        // setRenderSentence('Rendering packshot...');
                        if(data.quality === "low"){
                            setLowQualityStatusInner("rendering");
                            setLowQualityRendering(true);
                        }
                        if(data.quality === "medium"){
                            setMediumQualityStatusInner("rendering");
                            setMediumQualityRendering(true);
                        }
                        if(data.quality === "high"){
                            setHighQualityStatusInner("rendering");
                            setHighQualityRendering(true);
                        }
                    }

                    if (data.status === 'completed') {
                        if(data.quality === "low"){
                            setLowQualityStatusInner("completed");
                        }
                        if(data.quality === "medium"){
                            setMediumQualityStatusInner("completed");
                        }
                        if(data.quality === "high"){
                            setHighQualityStatusInner("completed");
                        }

                        if(data.quality === "low"){
                            setLowPackshotUrl(data.download_path);
                            setLowQualityRendering(false);
                            setPackshotDetailThumbnail(data.download_path);

                        }
                        if(data.quality === "medium"){
                            setMediumQualityRendering(false);
                            setMediumPackshotUrl(data.download_path);
                            setPackshotDetailThumbnail(data.download_path);
                        }
                        if(data.quality === "high"){
                            setHighQualityRendering(false);
                            setHighPackshotUrl(data.download_path);
                            setPackshotDetailThumbnail(data.download_path);
                        }
                        // loadRenderViews();


                        //
                        // setRenderSentence('Your packshot is ready !');
                        // setDownloadPackshotSentence(data.downloadPath);
                        // setDownloadPackshotImage(data.downloadPath);
                    }
                    if (data.status === 'error') {

                        if(data.quality === "low"){
                            setLowQualityRendering(false);
                            triggerWarning(language === "cs" ? "Packshot v nízké kvalitě narazil na problém, zkuste to prosím později nebo kontaktujte podporu" : "There was some error with low quality packshot, please try again or contact support");


                        }
                        if(data.quality === "medium"){
                            setMediumQualityRendering(false);
                            triggerWarning(language === "cs" ? "Packshot ve střední kvalitě narazil na problém, zkuste to prosím později nebo kontaktujte podporu" : "There was some error with medium quality packshot, please try again or contact support");
                        }
                        if(data.quality === "high"){
                            setHighQualityRendering(false);
                            triggerWarning(language === "cs" ? "Packshot ve vysoké kvalitě narazil na problém, zkuste to prosím později nebo kontaktujte podporu" : "There was some error with high quality packshot, please try again or contact support");
                        }





                        refreshAuthInfo();

                        //  setCurrentCreditsAlocate( currentCreditsAlocate -  data.credit_cost);
                        //    setTeamCreditsInner(teamCreditsInner + data.credit_cost);
                    }
                    if (data.status === 'canceled') {

                        if(data.quality === "low"){
                            setLowQualityRendering(false);
                            triggerWarning(language === "cs" ? "Váš packshot byl zrušen, zkuste to prosím znovu nebo kontaktujte podporu" : "Your packshot was canceled, please try again or contact support");


                        }
                        if(data.quality === "medium"){
                            setMediumQualityRendering(false);
                            triggerWarning(language === "cs" ? "Váš packshot byl zrušen, zkuste to prosím znovu nebo kontaktujte podporu" : "Your packshot was canceled, please try again or contact support");
                        }
                        if(data.quality === "high"){
                            setHighQualityRendering(false);
                            triggerWarning(language === "cs" ? "Váš packshot byl zrušen, zkuste to prosím znovu nebo kontaktujte podporu" : "Your packshot was canceled, please try again or contact support");
                        }





                        refreshAuthInfo();

                        //  setCurrentCreditsAlocate( currentCreditsAlocate -  data.credit_cost);
                        //    setTeamCreditsInner(teamCreditsInner + data.credit_cost);
                    }
                }

            }

        });
        socket.on('delete', data => {
            console.log(data);
        });



        return () => {


            // Zastavit všechny běžící odpočty při čištění
            stopCountdown("low");
            stopCountdown("medium");
            stopCountdown("high");
        };

    };

    const intl = useIntl();
    function truncateString(str, maxLength) {
        if (!str) {
            return str; // Vrací null nebo undefined, pokud to byl vstup
        }
        if (str.length > maxLength) {
            return `${str.substring(0, maxLength)}...`;
        }
        return str;
    }

    return (
        <>
            <RenderModalWrapper className={`  ${showRenderModalTransition ? 'showTransition' : 'hideTransition'} ${!showRenderModal ? 'hiddeComplete' : ''} packshots`}>


                <div id={'packshotModal'} className={`modal-window ${showRenderModal ? '' : 'hideModal'}`}>
                    <div className="modal-content">
                        <div className={'packshotsHeader'}>
                            {packshotDetailOpened ?
                                <div style={{ display: 'inline-block' }}>

                                    <h4 onClick={() => setPackshotDetailOpened(false)} className={'withHover'}>
                                        <FormattedMessage {...messages.main_menu_button_render_packshot}></FormattedMessage>
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                             className={'fa-caret-right halfing'}
                                             viewBox="0 0 256 512">
                                            <path
                                                d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z" />
                                        </svg>
                                    </h4>
                                    <h4 style={{ opacity: '0.5' }}>
                                        {truncateString(packshotDetailName ? intl.formatMessage({ id: packshotDetailName }) : null, 17)}

                                    </h4>
                                </div> :
                                <h4><FormattedMessage {...messages.main_menu_button_render_packshot}></FormattedMessage>
                                </h4>
                            }


                            <div className={'packshotsHeaderRight'}>
                            <span className={'creditsHeader'}>   <FormattedMessage {...messages.packshots_credits_available}></FormattedMessage>:  <b>{authData.teamCredits} </b>
                             <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                  style={{ marginLeft: '5px', marginTop: '-2px' }}
                                  viewBox="0 0 14 14" fill="none">
                                                <path
                                                    d="M4.87751 7.87231L0.0528927 7.87231C0.483663 11.3239 3.42905 13.9946 6.99904 13.9946C7.96289 13.9946 8.87828 13.8008 9.71289 13.4508L7.30058 9.27231C6.78366 8.37847 5.90597 7.87231 4.87751 7.87231Z"
                                                    fill="#ffffff" />
                                                <path
                                                    d="M7.30058 4.72231L9.71289 0.543846C8.87828 0.193846 7.96289 0 6.99904 0C3.42905 0 0.483663 2.67077 0.0528927 6.12231L4.87751 6.12231C5.90597 6.12231 6.78905 5.61615 7.30058 4.72231Z"
                                                    fill="#ffffff" />
                                            </svg>
                            </span>

                                <GlobalButtonFinal
                                    onClick={() => handleClickBuyCredits()}
                                    className={'btn-circle  borderWhite inviteMember'} data-uuid={'productID'}
                                    style={{ marginLeft: '30px' }}>
                                    <FontAwesomeIcon icon={faPlus} />
                                    <FormattedMessage {...messages.payments_credits_buy_credits}></FormattedMessage>
                                </GlobalButtonFinal>

                                <GlobalButtonFinal
                                    onClick={() => closeRenderShow()}
                                    style={{ marginLeft: '30px' }}
                                    className={'btn-circle borderWhite inviteMember'} data-uuid={'productID'}>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 384 512">
                                        <path
                                            d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z" />
                                    </svg>
                                    <FormattedMessage {...messages.packshots_modal_close}></FormattedMessage>
                                </GlobalButtonFinal>
                            </div>


                        </div>

                        <div className={`modal-content packshotsList `}>

                            <div className={` renderList  ${packshotDetailOpened || loadRendersShow ? 'hide' : ''} `} id="content"
                                 style={{ marginTop: '-40px' }}>

                                <>


                                    {packshotsListRef.current && packshotsListRef.current.map((value, index) => {

                                        return (
                                            <NewProduct
                                                name={intl.formatMessage({ id: value.name })}
                                                description={
                                                    value.description
                                                }
                                                getRenderStatusMessage={getRenderStatusMessage}
                                                completed_renders={value.completed_renders}
                                                running_renders={value.running_renders}
                                                isPackshots={true}
                                                coming_soon={false}
                                                thumnail={value.thumbnail}
                                                uuid={value.uuid}
                                                clickEvent={choosePackshotDetail}
                                            />
                                        );
                                    })}
                                   {/* <NewProduct
                                        isPackshots={true}
                                        showSupport={showSupport}
                                        type={'AddNew'}
                                        coming_soon={false}
                                    />*/}
                                </>

                            </div>

                            <div className={` renderDetail  ${packshotDetailOpened && !loadRendersShow ? 'pullup' : ''} `}>

                                <div className={'renderDetailThumb'}>

                                    <img style={ { maxWidth: '80%' }}
                                         src={packshotDetailThumbnail ? packshotDetailThumbnail : '/images/thumb_obalero.png'} />

                                </div>

                                <div className={'renderDetailDescription'}>
                                    <h1>{packshotDetailName ? intl.formatMessage({ id: packshotDetailName}) : null}</h1>
                                    <div className={'breadcrumbs'}>

                                    </div>

                                    <div className={'description'}>
                                <span>
                               {packshotDetailDescription}
                                    </span>
                                    </div>


                                    <div style={{ marginTop: '30px', width: '100%', display: 'inline-block' }}
                                         className={'resolutionBox'}>
                                        <h2>Low-Res</h2>

                                        <div className={'description'}>
                                            <span style={{ marginTop: '5px' }}><FormattedMessage {...messages.packshots_lowres_description}></FormattedMessage></span>
                                            <br /> <br />
                                            <span style={{ marginTop: '5px' }}><b><FormattedMessage {...messages.packshots_size_description}></FormattedMessage>:</b> 220 x 500 px</span><br />
                                            <span><b>Licence:</b> Royalty‑Free Commercial</span>
                                            <br />
                                            {lowPackshotDate ?
                                                <span><b><FormattedMessage {...messages.packshots_created_description}></FormattedMessage>:</b> {new Date(lowPackshotDate).toLocaleString()} </span>
                                                : null
                                            }

                                        </div>
                                        <div className={'buttons'}>


                                            {lowPackshotUrl ?
                                                <>


                                                        <GlobalButtonFinal
                                                            onClick={!lowQualityRendering ? ()=>downloadPackshot(lowPackshotUrl) : null}
                                                            style={{
                                                                marginLeft: '0',
                                                                marginTop: '15px',
                                                                width: '100%',
                                                            }}
                                                            disabled={lowQualityRendering ? true : false}
                                                            className={lowQualityRendering ? 'backgroundGray btn-circle' : 'backgroundWhite btn-circle'}
                                                        >
                                                            <FontAwesomeIcon icon={faDownload}
                                                                             style={{ marginRight: '5px' }} />
                                                            <FormattedMessage {...messages.packshots_download}></FormattedMessage>
                                                        </GlobalButtonFinal>


                                                    {lowQualityRendering ?
                                                        <>
                                                            <GlobalButtonFinal
                                                                style={{
                                                                    marginLeft: '0',
                                                                    marginTop: '5px',
                                                                    width: '100%',
                                                                }}
                                                                disabled={lowQualityRendering ? true : false}
                                                                className={'borderWhite btn-circle'}
                                                                onClick={!lowQualityRendering ? () => openRenderPackshot('low', pricingLow, estimatedTimeRenderLow) : null}
                                                            >

                                                                {getRenderStatusMessage("low",lowQualityStatusInner && lowQualityStatusInner !== "completed" ? lowQualityStatusInner : "pending")}
                                                                <img style={{
                                                                    filter: 'invert(1)',
                                                                    maxWidth: '100%',
                                                                    height: '23px',
                                                                    position: 'relative',
                                                                    float: 'right',
                                                                    top: '1px',
                                                                }} src={'/logoAnimate.svg'} />
                                                            </GlobalButtonFinal>
                                                            <span>
                                                                <FormattedMessage {...messages.packshots_estimated_time} />
                                                                    {lowQualityRendering && displayTimeLow !== null ?
                                                                        formatCountdownTime(displayTimeLow) :
                                                                        `${estimatedTimeRenderLow} min`}
                                                            </span>
                                                            {/*<span><FormattedMessage {...messages.packshots_estimated_time}></FormattedMessage>{estimatedTimeRenderLow} min</span>*/}

                                                        </>

                                                        :
                                                        <GlobalButtonFinal
                                                            style={{
                                                                marginLeft: '0',
                                                                marginTop: '5px',
                                                                width: '100%',
                                                            }}
                                                            disabled={lowQualityRendering ? true : false}
                                                            className={'backgroundWhite btn-circle'}
                                                            onClick={!lowQualityRendering ? () => openRenderPackshot('low', pricingLow, estimatedTimeRenderLow) : null}
                                                        >
                                                            <FontAwesomeIcon icon={faCamera}
                                                                             style={{ marginRight: '5px' }} />
                                                            <FormattedMessage {...messages.packshots_create}></FormattedMessage>

                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14"
                                                                 height="14"
                                                                 className={'coin'}
                                                                 style={{
                                                                     marginLeft: '5px',
                                                                     float: 'right',
                                                                 }}
                                                                 viewBox="0 0 14 14" fill="none">
                                                                <path
                                                                    d="M4.87751 7.87231L0.0528927 7.87231C0.483663 11.3239 3.42905 13.9946 6.99904 13.9946C7.96289 13.9946 8.87828 13.8008 9.71289 13.4508L7.30058 9.27231C6.78366 8.37847 5.90597 7.87231 4.87751 7.87231Z"
                                                                    fill="#3D55D7" />
                                                                <path
                                                                    d="M7.30058 4.72231L9.71289 0.543846C8.87828 0.193846 7.96289 0 6.99904 0C3.42905 0 0.483663 2.67077 0.0528927 6.12231L4.87751 6.12231C5.90597 6.12231 6.78905 5.61615 7.30058 4.72231Z"
                                                                    fill="#3D55D7" />
                                                            </svg>
                                                            <b style={{ float: 'right' }}>{pricingLow}</b>
                                                        </GlobalButtonFinal>
                                                    }

                                                </>
                                                :

                                                <>
                                                    {lowQualityRendering ?

                                                        <>
                                                            <GlobalButtonFinal
                                                                style={{
                                                                    marginLeft: '0',
                                                                    marginTop: '5px',
                                                                    width: '100%',
                                                                }}
                                                                disabled={lowQualityRendering ? true : false}
                                                                className={'borderWhite btn-circle'}
                                                                onClick={!lowQualityRendering ? () => openRenderPackshot('low', pricingLow, estimatedTimeRenderLow) : null}
                                                            >
                                                                {getRenderStatusMessage("low",lowQualityStatusInner && lowQualityStatusInner !== "completed" ? lowQualityStatusInner : "pending")}
                                                                <img style={{
                                                                    maxWidth: '100%',
                                                                    height: '23px',
                                                                    position: 'relative',
                                                                    float: 'right',
                                                                    top: '1px',
                                                                    filter: 'invert(1)',
                                                                }} src={'/logoAnimate.svg'} />
                                                            </GlobalButtonFinal>

                                                            <span>
                                                                <FormattedMessage {...messages.packshots_estimated_time} />
                                                                {lowQualityRendering && displayTimeLow !== null ?
                                                                    formatCountdownTime(displayTimeLow) :
                                                                    `${estimatedTimeRenderLow} min`}
                                                            </span>
                                                            {/*<span><FormattedMessage {...messages.packshots_estimated_time}></FormattedMessage>{estimatedTimeRenderLow} min</span>*/}

                                                        </>

                                                        :
                                                        <GlobalButtonFinal
                                                            style={{
                                                                marginLeft: '0',
                                                                marginTop: '5px',
                                                                width: '100%',
                                                            }}
                                                            disabled={lowQualityRendering ? true : false}
                                                            className={'backgroundWhite btn-circle'}
                                                            onClick={!lowQualityRendering ? () => openRenderPackshot('low', pricingLow, estimatedTimeRenderLow) : null}
                                                        >
                                                            <FontAwesomeIcon icon={faCamera}
                                                                             style={{ marginRight: '5px' }} />
                                                            <FormattedMessage {...messages.packshots_create}></FormattedMessage>


                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14"
                                                                 height="14"
                                                                 className={'coin'}
                                                                 style={{
                                                                     marginLeft: '5px',
                                                                     float: 'right',
                                                                 }}
                                                                 viewBox="0 0 14 14" fill="none">
                                                                <path
                                                                    d="M4.87751 7.87231L0.0528927 7.87231C0.483663 11.3239 3.42905 13.9946 6.99904 13.9946C7.96289 13.9946 8.87828 13.8008 9.71289 13.4508L7.30058 9.27231C6.78366 8.37847 5.90597 7.87231 4.87751 7.87231Z"
                                                                    fill="#3D55D7" />
                                                                <path
                                                                    d="M7.30058 4.72231L9.71289 0.543846C8.87828 0.193846 7.96289 0 6.99904 0C3.42905 0 0.483663 2.67077 0.0528927 6.12231L4.87751 6.12231C5.90597 6.12231 6.78905 5.61615 7.30058 4.72231Z"
                                                                    fill="#3D55D7" />
                                                            </svg>
                                                            <b style={{ float: 'right' }}>{pricingLow}</b>
                                                        </GlobalButtonFinal>
                                                    }
                                                </>
                                            }


                                        </div>


                                    </div>

                                    <div style={{ marginTop: '30px', width: '100%', display: 'inline-block' }}
                                         className={'resolutionBox'}>
                                        <h2>Mid-Res</h2>

                                        <div className={'description'}>
                                            <span style={{ marginTop: '5px' }}><FormattedMessage {...messages.packshots_midres_description}></FormattedMessage></span>
                                            <br /> <br />
                                            <span
                                                style={{ marginTop: '5px' }}><b><FormattedMessage {...messages.packshots_size_description}></FormattedMessage>:</b> 1100 ⨯ 2500 px</span><br />
                                            <span><b>Licence:</b> Royalty‑Free Commercial</span>
                                            <br />
                                            {mediumPackshotDate ?
                                                <span><b><FormattedMessage {...messages.packshots_created_description}></FormattedMessage>:</b> {new Date(mediumPackshotDate).toLocaleString()}</span>
                                                : null
                                            }

                                        </div>
                                        <div className={'buttons'}>

                                            {mediumPackshotUrl ?
                                                <>

                                                        <GlobalButtonFinal
                                                            onClick={!mediumQualityRendering ? ()=>downloadPackshot(mediumPackshotUrl) : null}
                                                            style={{
                                                                marginLeft: '0',
                                                                marginTop: '5px',
                                                                width: '100%',
                                                            }}
                                                            disabled={mediumQualityRendering ? true : false}
                                                            className={mediumQualityRendering ? 'backgroundGray btn-circle' : 'backgroundWhite btn-circle'}
                                                        >
                                                            <FontAwesomeIcon icon={faDownload}
                                                                             style={{ marginRight: '5px' }} />    <FormattedMessage {...messages.packshots_download}></FormattedMessage>
                                                        </GlobalButtonFinal>


                                                    {mediumQualityRendering ?
                                                        <>
                                                            <GlobalButtonFinal
                                                                style={{
                                                                    marginLeft: '0',
                                                                    marginTop: '5px',
                                                                    width: '100%',
                                                                }}
                                                                className={'borderWhite btn-circle'}
                                                                onClick={() => openRenderPackshot('medium', pricingMedium, estimatedTimeRenderMid)}
                                                            >
                                                                {getRenderStatusMessage("medium",mediumQualityStatusInner && mediumQualityStatusInner !== "completed"  ? mediumQualityStatusInner : "pending")}
                                                                <img style={{
                                                                    maxWidth: '100%',
                                                                    height: '23px',
                                                                    position: 'relative',
                                                                    float: 'right',
                                                                    top: '1px',
                                                                    filter: 'invert(1)',
                                                                }} src={'/logoAnimate.svg'} />
                                                            </GlobalButtonFinal>
                                                            <span>
                                                                <FormattedMessage {...messages.packshots_estimated_time} />
                                                                {mediumQualityRendering && displayTimeMedium !== null ?
                                                                    formatCountdownTime(displayTimeMedium) :
                                                                    `${estimatedTimeRenderMid} min`}
                                                            </span>

                                                        </>

                                                        :
                                                        <GlobalButtonFinal
                                                            style={{
                                                                marginLeft: '0',
                                                                marginTop: '5px',
                                                                width: '100%',
                                                            }}
                                                            className={'backgroundWhite btn-circle'}
                                                            onClick={() => openRenderPackshot('medium', pricingMedium, estimatedTimeRenderMid)}
                                                        >
                                                            <FontAwesomeIcon icon={faCamera}
                                                                             style={{ marginRight: '5px' }} />
                                                            <FormattedMessage {...messages.packshots_create}></FormattedMessage>


                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14"
                                                                 height="14"
                                                                 className={'coin'}
                                                                 style={{
                                                                     marginLeft: '5px',
                                                                     float: 'right',
                                                                 }}
                                                                 viewBox="0 0 14 14" fill="none">
                                                                <path
                                                                    d="M4.87751 7.87231L0.0528927 7.87231C0.483663 11.3239 3.42905 13.9946 6.99904 13.9946C7.96289 13.9946 8.87828 13.8008 9.71289 13.4508L7.30058 9.27231C6.78366 8.37847 5.90597 7.87231 4.87751 7.87231Z"
                                                                    fill="#3D55D7" />
                                                                <path
                                                                    d="M7.30058 4.72231L9.71289 0.543846C8.87828 0.193846 7.96289 0 6.99904 0C3.42905 0 0.483663 2.67077 0.0528927 6.12231L4.87751 6.12231C5.90597 6.12231 6.78905 5.61615 7.30058 4.72231Z"
                                                                    fill="#3D55D7" />
                                                            </svg>
                                                            <b style={{ float: 'right' }}>{pricingMedium}</b>
                                                        </GlobalButtonFinal>
                                                    }


                                                </>
                                                :
                                                <>
                                                    {mediumQualityRendering ?

                                                        <>
                                                            <GlobalButtonFinal
                                                                style={{
                                                                    marginLeft: '0',
                                                                    marginTop: '5px',
                                                                    width: '100%',
                                                                }}
                                                                className={'borderWhite btn-circle'}
                                                                onClick={() => openRenderPackshot('medium', pricingMedium, estimatedTimeRenderMid)}
                                                            >
                                                                {getRenderStatusMessage("medium",mediumQualityStatusInner && mediumQualityStatusInner !== "completed" ? mediumQualityStatusInner : "pending")}
                                                                <img style={{
                                                                    maxWidth: '100%',
                                                                    height: '23px',
                                                                    position: 'relative',
                                                                    float: 'right',
                                                                    top: '1px',
                                                                    filter: 'invert(1)',
                                                                }} src={'/logoAnimate.svg'} />
                                                            </GlobalButtonFinal>
                                                            <span>
                                                                <FormattedMessage {...messages.packshots_estimated_time} />
                                                                {mediumQualityRendering && displayTimeMedium !== null ?
                                                                    formatCountdownTime(displayTimeMedium) :
                                                                    `${estimatedTimeRenderMid} min`}
                                                            </span>

                                                            {/*<span><FormattedMessage {...messages.packshots_estimated_time}></FormattedMessage>{estimatedTimeRenderMid} min</span>*/}
                                                        </>

                                                        :
                                                        <GlobalButtonFinal
                                                            style={{
                                                                marginLeft: '0',
                                                                marginTop: '15px',
                                                                width: '100%',
                                                            }}
                                                            className={'backgroundWhite btn-circle'}
                                                            onClick={() => openRenderPackshot('medium', pricingMedium, estimatedTimeRenderMid)}
                                                        >
                                                            <FontAwesomeIcon icon={faCamera}
                                                                             style={{ marginRight: '5px' }} />
                                                            <FormattedMessage {...messages.packshots_create}></FormattedMessage>


                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14"
                                                                 height="14"
                                                                 className={'coin'}
                                                                 style={{
                                                                     marginLeft: '5px',
                                                                     float: 'right',
                                                                 }}
                                                                 viewBox="0 0 14 14" fill="none">
                                                                <path
                                                                    d="M4.87751 7.87231L0.0528927 7.87231C0.483663 11.3239 3.42905 13.9946 6.99904 13.9946C7.96289 13.9946 8.87828 13.8008 9.71289 13.4508L7.30058 9.27231C6.78366 8.37847 5.90597 7.87231 4.87751 7.87231Z"
                                                                    fill="#3D55D7" />
                                                                <path
                                                                    d="M7.30058 4.72231L9.71289 0.543846C8.87828 0.193846 7.96289 0 6.99904 0C3.42905 0 0.483663 2.67077 0.0528927 6.12231L4.87751 6.12231C5.90597 6.12231 6.78905 5.61615 7.30058 4.72231Z"
                                                                    fill="#3D55D7" />
                                                            </svg>
                                                            <b style={{ float: 'right' }}>{pricingMedium}</b>
                                                        </GlobalButtonFinal>
                                                    }
                                                </>
                                            }

                                        </div>


                                    </div>

                                    <div style={{ marginTop: '30px', width: '100%', display: 'inline-block' }}
                                         className={'resolutionBox'}>
                                        <h2>High-Res</h2>

                                        <div className={'description'}>
                                            <span style={{ marginTop: '5px' }}><FormattedMessage {...messages.packshots_highres_description}></FormattedMessage></span><br /><br/>
                                            <span
                                                style={{ marginTop: '5px' }}><b><FormattedMessage {...messages.packshots_size_description}></FormattedMessage>:</b> 2200 ⨯ 5000 px</span>
<br/>
                                            <span><b>Licence:</b> Royalty‑Free Commercial</span>
                                            {highPackshotDate ?
                                                <span><b>   <FormattedMessage {...messages.packshots_created_description}></FormattedMessage>:</b> {new Date(highPackshotDate).toLocaleString()}</span>
                                                : null
                                            }
                                        </div>
                                        <div className={'buttons'}>

                                            {highPackshotUrl ?
                                                <>

                                                        <GlobalButtonFinal
                                                            onClick={!highQualityRendering ? ()=>downloadPackshot(highPackshotUrl) : null}
                                                            style={{
                                                                marginLeft: '0',
                                                                marginTop: '5px',
                                                                width: '100%',
                                                            }}
                                                            disabled={highQualityRendering ? true : false}
                                                            className={highQualityRendering ? 'backgroundGray btn-circle' : 'backgroundWhite btn-circle'}
                                                        >
                                                            <FontAwesomeIcon icon={faDownload}
                                                                             style={{ marginRight: '5px' }} />    <FormattedMessage {...messages.packshots_download}></FormattedMessage>
                                                        </GlobalButtonFinal>



                                                    {highQualityRendering ?
                                                        <>
                                                            <GlobalButtonFinal
                                                                style={{
                                                                    marginLeft: '0',
                                                                    marginTop: '5px',
                                                                    width: '100%',
                                                                }}
                                                                className={'borderWhite btn-circle'}
                                                                onClick={() => openRenderPackshot('high', pricingHigh, estimatedTimeRenderHigh)}
                                                            >
                                                                {getRenderStatusMessage("high",highQualityStatusInner && highQualityStatusInner !== "completed"  ? highQualityStatusInner : "pending")}
                                                                <img style={{
                                                                    maxWidth: '100%',
                                                                    height: '23px',
                                                                    position: 'relative',
                                                                    float: 'right',
                                                                    top: '1px',
                                                                    filter: 'invert(1)',
                                                                }} src={'/logoAnimate.svg'} />
                                                            </GlobalButtonFinal>

                                                            <span>
                                                                <FormattedMessage {...messages.packshots_estimated_time} />
                                                                {highQualityRendering && displayTimeHigh !== null ?
                                                                    formatCountdownTime(displayTimeHigh) :
                                                                    `${estimatedTimeRenderHigh} min`}
                                                            </span>

                                                            {/*<span><FormattedMessage {...messages.packshots_estimated_time}></FormattedMessage>{estimatedTimeRenderHigh} min</span>*/}
                                                        </>

                                                        :
                                                        <GlobalButtonFinal
                                                            style={{
                                                                marginLeft: '0',
                                                                marginTop: '5px',
                                                                width: '100%',
                                                            }}
                                                            className={'backgroundWhite btn-circle'}
                                                            onClick={() => openRenderPackshot('high', pricingHigh, estimatedTimeRenderHigh)}
                                                        >
                                                            <FontAwesomeIcon icon={faCamera}
                                                                             style={{ marginRight: '5px' }} />
                                                            <FormattedMessage {...messages.packshots_create}></FormattedMessage>


                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14"
                                                                 height="14"
                                                                 className={'coin'}
                                                                 style={{
                                                                     marginLeft: '5px',
                                                                     float: 'right',
                                                                 }}
                                                                 viewBox="0 0 14 14" fill="none">
                                                                <path
                                                                    d="M4.87751 7.87231L0.0528927 7.87231C0.483663 11.3239 3.42905 13.9946 6.99904 13.9946C7.96289 13.9946 8.87828 13.8008 9.71289 13.4508L7.30058 9.27231C6.78366 8.37847 5.90597 7.87231 4.87751 7.87231Z"
                                                                    fill="#3D55D7" />
                                                                <path
                                                                    d="M7.30058 4.72231L9.71289 0.543846C8.87828 0.193846 7.96289 0 6.99904 0C3.42905 0 0.483663 2.67077 0.0528927 6.12231L4.87751 6.12231C5.90597 6.12231 6.78905 5.61615 7.30058 4.72231Z"
                                                                    fill="#3D55D7" />
                                                            </svg>
                                                            <b style={{ float: 'right' }}>{pricingHigh}</b>
                                                        </GlobalButtonFinal>
                                                    }


                                                </>
                                                :
                                                <>


                                                    {highQualityRendering ?

                                                        <>
                                                            <GlobalButtonFinal
                                                                style={{
                                                                    marginLeft: '0',
                                                                    marginTop: '5px',
                                                                    width: '100%',
                                                                }}
                                                                className={'borderWhite btn-circle'}
                                                                onClick={() => openRenderPackshot('high', pricingHigh, estimatedTimeRenderHigh)}
                                                            >
                                                                {getRenderStatusMessage("high",highQualityStatusInner && highQualityStatusInner !== "completed" ? highQualityStatusInner : "pending")}
                                                                <img style={{
                                                                    maxWidth: '100%',
                                                                    height: '23px',
                                                                    position: 'relative',
                                                                    float: 'right',
                                                                    top: '1px',
                                                                    filter: 'invert(1)',
                                                                }} src={'/logoAnimate.svg'} />
                                                            </GlobalButtonFinal>
                                                            <span>
                                                                <FormattedMessage {...messages.packshots_estimated_time} />
                                                                {highQualityRendering && displayTimeHigh !== null ?
                                                                    formatCountdownTime(displayTimeHigh) :
                                                                    `${estimatedTimeRenderHigh} min`}
                                                            </span>
                                                        </>

                                                        :
                                                        <GlobalButtonFinal
                                                            style={{
                                                                marginLeft: '0',
                                                                marginTop: '5px',
                                                                width: '100%',
                                                            }}
                                                            className={'backgroundWhite btn-circle'}
                                                            onClick={() => openRenderPackshot('high', pricingHigh, estimatedTimeRenderHigh)}
                                                        >
                                                            <FontAwesomeIcon icon={faCamera}
                                                                             style={{ marginRight: '5px' }} />
                                                            <FormattedMessage {...messages.packshots_create}></FormattedMessage>


                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14"
                                                                 height="14"
                                                                 className={'coin'}
                                                                 style={{
                                                                     marginLeft: '5px',
                                                                     float: 'right',
                                                                 }}
                                                                 viewBox="0 0 14 14" fill="none">
                                                                <path
                                                                    d="M4.87751 7.87231L0.0528927 7.87231C0.483663 11.3239 3.42905 13.9946 6.99904 13.9946C7.96289 13.9946 8.87828 13.8008 9.71289 13.4508L7.30058 9.27231C6.78366 8.37847 5.90597 7.87231 4.87751 7.87231Z"
                                                                    fill="#3D55D7" />
                                                                <path
                                                                    d="M7.30058 4.72231L9.71289 0.543846C8.87828 0.193846 7.96289 0 6.99904 0C3.42905 0 0.483663 2.67077 0.0528927 6.12231L4.87751 6.12231C5.90597 6.12231 6.78905 5.61615 7.30058 4.72231Z"
                                                                    fill="#3D55D7" />
                                                            </svg>
                                                            <b style={{ float: 'right' }}>{pricingHigh}</b>
                                                        </GlobalButtonFinal>
                                                    }
                                                </>
                                            }

                                        </div>


                                    </div>


                                </div>
                            </div>


                            <LoaderProducts className={`renders-loader ${loadTransitionRendersShow ? 'showTransition' : 'hideTransition'} ${!loadRendersShow ? 'hiddeComplete' : ''} `} style={{
                                background: "transparent",
                                position: "fixed",
                                left: "0px",
                                minHeight: "300px",
                                width: "100%",
                                height: "300px",
                                top: "200px",
                                filter:"invert(1)"

                            }}>
                                <img src={'/logoAnimate.svg'} />
                            </LoaderProducts>


                        </div>

                    </div>
                </div>


                <GlobalButtonFinal
                    style={{ marginLeft: '30px', position:"fixed",left:"0", bottom:"15px" }}
                    className={'btn-circle borderWhite inviteMember'}
                    data-closeintercombreak={"true"}
                    onClick={(e) =>showSupport2(e)}
                    data-uuid={'productID'}>
                    <FormattedMessage {...messages.packshots_request_custom_view}></FormattedMessage>

                </GlobalButtonFinal>

            </RenderModalWrapper>
            <DialogBuyCredits
                triggerWarning={triggerWarning}
                toggleBuyCredits={ (toggleBuyCredits: () => void) => {
                    handleClickBuyCredits = toggleBuyCredits;
                } }
                setPaymentStateCallback={setPaymentStateCallback}
                stateBuyBack={paymentStateCallback ? 4 : null}
                paymentStateSessionIDCallback={paymentStateSessionIDCallback}
                paymentStateCallback={paymentStateCallback}
                redirectURL={window.location.href.includes("editor") ? "editor/"+slug : "/packshots-detail/" + slug}
            />

        </>

    );
}
